import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgModule } from '@angular/core';
import { RxCheckboxComponent } from './rx-checkbox.component';

@NgModule({
  imports: [CommonModule, MatCheckboxModule, FormsModule, RxCheckboxComponent],
  exports: [RxCheckboxComponent],
})
export class RxCheckboxModule {}
